import { DateTime } from 'luxon';
import { LocaleFormats } from '../types';

export const localeDateFormats: LocaleFormats = {
  en_US: 'MM-dd-yyyy',
  fr_CA: 'yyyy-MM-dd'
};

export const localeDateInterCompanyFormats: LocaleFormats = {
  en_US: 'MM/DD/YYYY',
  fr_CA: 'MM/DD/YYYY'
};

export const getDateFormat = (locale = 'en_US'): string => {
  if (locale === 'en') {
    return localeDateFormats.en_US;
  }
  if (locale === 'fr') {
    return localeDateFormats.fr_CA;
  }

  return localeDateFormats[locale] || localeDateFormats.en_US;
};

export const getDateFormatForInterCompany = (locale = 'en_US'): string => {
  if (locale === 'en') {
    return localeDateInterCompanyFormats.en_US;
  }
  if (locale === 'fr') {
    return localeDateInterCompanyFormats.fr_CA;
  }

  return (
    localeDateInterCompanyFormats[locale] || localeDateInterCompanyFormats.en_US
  );
};

export const getDateFormatByLocale = (locale = 'en_US'): string =>
  getDateFormat(locale).toUpperCase();

export const getDateFormatByLocaleForInterCompany = (
  locale = 'en_US'
): string => getDateFormatForInterCompany(locale).toUpperCase();

export const formatLocaleDate = (
  date?: string | Date | null,
  locale = 'en_US'
): string => {
  if (!date) {
    return '';
  }

  let dateObject;

  if (typeof date === 'string') {
    dateObject = DateTime.fromISO(date);
  } else if (date instanceof Date) {
    dateObject = DateTime.fromJSDate(date);
  }

  const dateFormat = getDateFormat(locale);
  return dateObject?.isValid ? dateObject.toFormat(dateFormat) : '';
};

export const formattedDate = (date: string | Date | null): string => {
  if (!date) {
    return '';
  }

  if (DateTime.fromJSDate(date as Date).isValid) {
    return DateTime.fromJSDate(date as Date).toISODate();
  }

  if (DateTime.fromISO(date as string).isValid) {
    return DateTime.fromISO(date as string).toISODate();
  }

  if (DateTime.fromFormat(date as string, 'MM/dd/yyyy').isValid) {
    return DateTime.fromFormat(date as string, 'MM/dd/yyyy').toISODate();
  }

  if (DateTime.fromFormat(date as string, 'MM/dd/yy').isValid) {
    return DateTime.fromFormat(date as string, 'MM/dd/yy').toISODate();
  }

  return '';
};
